import type { StoreActionApi } from 'react-sweet-state';
import { createStore, createHook, createActionsHook, createStateHook } from 'react-sweet-state';

import type {
	UnreadCommentsState,
	UnreadCommentIDSetOperation,
} from '../types/unreadCommentsTypes.ts';

const initialState = {
	shouldUpdateUnreadCommentsOnFirstRender: true,
	isUnreadQueryLoading: false,

	// this is the for updated unread comment list experience
	unreadCommentIDSet: new Set<string>(), // list of unread comment IDs
	shouldClearVisibleThreads: false,
};

const actions = {
	updateUnreadCommentsOnFirstRender:
		(shouldUpdateUnreadCommentsOnFirstRender: boolean) =>
		({ setState }: StoreActionApi<UnreadCommentsState>) => {
			setState({ shouldUpdateUnreadCommentsOnFirstRender });
		},

	setIsUnreadQueryLoading:
		(loading: boolean) =>
		({ setState }: StoreActionApi<UnreadCommentsState>) => {
			setState({ isUnreadQueryLoading: loading });
		},
	updateUnreadCommentIDSet:
		(unreadCommentIDSet: Set<string>, operation: UnreadCommentIDSetOperation = 'initialize') =>
		({ setState, getState }: StoreActionApi<UnreadCommentsState>) => {
			const { unreadCommentIDSet: existingSet } = getState();
			switch (operation) {
				case 'initialize':
					setState({ unreadCommentIDSet });
					break;
				case 'add':
					setState({
						unreadCommentIDSet: new Set([...existingSet, ...unreadCommentIDSet]),
					});
					break;
				case 'remove':
					const newSet = new Set(existingSet);
					unreadCommentIDSet.forEach((id) => newSet.delete(id));
					setState({ unreadCommentIDSet: newSet });
					break;
				case 'removeAll':
					setState({ unreadCommentIDSet: new Set() });
					break;
			}
		},
	setShouldClearVisibleThreads:
		(shouldClearVisibleThreads: boolean) =>
		({ setState }: StoreActionApi<UnreadCommentsState>) => {
			setState({ shouldClearVisibleThreads });
		},
};

const UnreadCommentsStore = createStore({
	initialState,
	actions,
	name: 'UnreadCommentsStore',
});

export const useUnreadComments = createHook(UnreadCommentsStore);
export const useUnreadCommentsActions = createActionsHook(UnreadCommentsStore);
export const useUnreadCommentsState = createStateHook(UnreadCommentsStore);
